<template>
  <div>
    <modal name="json-examples" :adaptive="true">
      <div id="kt_portlet_tools_1" class="kt-portlet" data-ktportlet="true">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-map" />
            </span>
            <h3 class="kt-portlet__head-title">
              Examples
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-portlet__content">
            <ul>
              <li>
                <a target="_blank" href="/build/examples/epg/example1.json">Example 1</a>
              </li>
              <li>
                <a target="_blank" href="/build/examples/epg/example2.json">Example 2</a>
              </li>
              <li>
                <a target="_blank" href="/build/examples/epg/example3.json">Example 3</a>
              </li>
            </ul>
            <br>
            <h6>
              <i class="fa fa-info" />
              To try it, please save an example to your computer. In chrome, for
              example, right click and select 'Save As...' Then try uploading and
              mapping it. Please note that there can be more structures but the more
              simple it is the better.
            </h6>
          </div>
        </div>
      </div>
    </modal>
    <div v-if="showSaveAlert" class="alert alert-info" role="alert">
      <strong>Heads up!</strong>
      You haven't saved the changes!
    </div>
    <div id="kt_portlet_tools_1" class="kt-portlet" data-ktportlet="true">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title" v-text="source ? source : 'Select a Source'" />
        </div>
        <div class="kt-portlet__head-toolbar">
          <div class="kt-portlet__head-group">
            <a href="javascript:void(0)"
               class="btn btn-sm btn-icon btn-clean btn-icon-md"
               @click="exampleJson()">
              <i class="la la-question-circle" />
            </a>
            <a href="javascript:void(0)"
               data-ktportlet-tool="toggle"
               class="btn btn-sm btn-icon btn-clean btn-icon-md">
              <i class="la la-angle-down" />
            </a>
          </div>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-portlet__content">
          <form id="my-dropzone" class="dropzone dropzone-file-area">
            <h4 v-if="source" class="filesource">
              {{ source }}
            </h4>
          </form>
        </div>
      </div>
    </div>
    <div id="kt_portlet_tools_1" class="kt-portlet" data-ktportlet="true">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            Mapping
          </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
          <div class="kt-portlet__head-group">
            <a
              href="#"
              data-ktportlet-tool="toggle"
              class="btn btn-sm btn-icon btn-clean btn-icon-md">
              <i class="la la-angle-down" />
            </a>
          </div>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-portlet__content">
          <div class="form-group kt-form__group row">
            <div class="col-lg-6">
              <label>Root</label>

              <div class="input-group">
                <multiselect
                  id="root"
                  v-model="root"
                  placeholder="Select root element..."
                  :options="rootList"
                  :searchable="true"
                  :allow-empty="false"
                  @input="makeRootJson" />
                <span class="kt-form__help">
                  Select a root element. Once selected it will update the mapping
                  suggestions below. * represents root location.
                </span>
              </div>
            </div>

            <div class="col-lg-6">
              <label for="timezone">Timezone</label>

              <multiselect
                v-model="timezoneSelected"
                style="margin-right: 5px;"
                :allow-empty="false"
                placeholder="Timezone"
                label="zone"
                track-by="zone"
                :options="timezones"
                :show-labels="false">
                <template slot="singleLabel" slot-scope="props">
                  <span class="option__title">{{ props.option.zone }}</span>
                </template>
                <template slot="option" slot-scope="props">
                  <span class="option__title">{{ props.option.zone }}</span>
                </template>
              </multiselect>

              <span class="kt-form__help">Select the input timezone</span>
            </div>
          </div>

          <div class="form-group kt-form__group row">
            <div class="col-lg-4">
              <label for="uuid">Uuid</label>
              <multiselect id="uuid" v-model="mapping.uuid" :options="mappingSuggestions" />
              <span class="kt-form__help">Select a value that is guaranteed to be unique!</span>
            </div>
            <div class="col-lg-4">
              <label for="name">Name</label>
              <multiselect id="name" v-model="mapping.name" :options="mappingSuggestions" />
              <span class="kt-form__help">Can be anything. If empty, 'untitled' will be used.</span>
            </div>
            <div class="col-lg-4">
              <label for="description">Description</label>
              <multiselect
                id="description"
                v-model="mapping.description"
                :options="mappingSuggestions" />
              <span class="kt-form__help">Can be empty.</span>
            </div>
          </div>
          <div class="form-group kt-form__group row">
            <div class="col-lg-4">
              <label for="image">Image</label>
              <multiselect id="image" v-model="mapping.image" :options="mappingSuggestions" />
              <span
                class="kt-form__help">Select a value that contains a url to an image, or leave it blank.</span>
            </div>
            <div class="col-lg-4">
              <label for="broadcast_start">Broadcast Start</label>
              <multiselect
                id="broadcast_start"
                v-model="mapping.broadcast_start"
                :options="mappingSuggestions" />
              <span
                class="kt-form__help">Must contain a value that represents date and time. Must be both!</span>
            </div>
            <div class="col-lg-4">
              <label for="broadcast_stop">Broadcast Stop</label>
              <multiselect
                id="broadcast_stop"
                v-model="mapping.broadcast_stop"
                :options="mappingSuggestions" />
              <span class="kt-form__help">
                Same as broadcast_start but should contain a value that is later
                than broadcast_start.
              </span>
            </div>
          </div>

          <div class="form-group kt-form__group row">
            <div class="col-lg-12">
              <label>Live Source</label>
              <input
                v-model="epg.liveSource"
                type="text"
                class="form-control form-control-lg"
                aria-describedby="liveSourceHelp"
                placeholder="Live Source">
              <span
                class="kt-form__help">Enter a url to a source epg with the same structure to the sample upload!</span>
            </div>
          </div>

          <div class="form-group kt-form__group row mt-4">
            <div v-if="source" class="col-12 toolbar mb-4 text-center">
              <button class="btn btn-ss" @click="previewMapping()">
                <span>
                  <i class="la la-rotate-right" />
                  <span>Update Preview</span>
                </span>
              </button>
              <a :href="`/epg/${epg.uuid}`" target="_blank" class="btn btn-ss">
                <span>
                  <i class="la la-search-plus" />
                  <span>Preview Feed</span>
                </span>
              </a>
              <button class="btn btn-ss-standout" @click="saveChanges()">
                <span>
                  <i class="la la-save" />
                  <span>Save</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kt-portlet kt-portlet--tabs">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            Preview
          </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
          <ul
            class="nav nav-tabs nav-tabs-bold nav-tabs-line nav-tabs-line-right nav-tabs-line-brand"
            role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                data-toggle="tab"
                href="#kt_portlet_tab_1_1"
                role="tab">Table</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab"
                 href="#kt_portlet_tab_1_2"
                 role="tab">Json</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="tab-content">
          <div id="kt_portlet_tab_1_1" class="tab-pane active">
            <div slot="Table">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Uuid</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Image</th>
                      <th>Broadcast Start</th>
                      <th>Broadcast Stop</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(x, index) in json.final" :key="index">
                      <th scope="row">
                        {{ index + 1 }}
                      </th>
                      <td>{{ x.uuid }}</td>
                      <td>{{ x.name }}</td>
                      <td>{{ x.description }}</td>
                      <td>
                        <img style="max-height: 100px;" :src="x.image">
                      </td>
                      <td>{{ x.broadcast_start }}</td>
                      <td>{{ x.broadcast_stop }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div id="kt_portlet_tab_1_2" class="tab-pane">
            <vue-json-pretty :data="json.final" :deep="1" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueJsonPretty from "vue-json-pretty";
import AsyncComputed from "vue-async-computed";
Vue.use(AsyncComputed);

if (window.Dropzone) {
  window.Dropzone.autoDiscover = false; // do not automatically look for dropzone!
}
export default {
  asyncComputed: {
    async index() {
      try {
        const response = await axios.get(`/api/v1/epg/items/${window.epg.uuid}`);

        if (response.data.data.json != null) {
          this.json.original = response.data.data.json;
        }

        if (response.data.data.root != null) {
          this.root = response.data.data.root;
        }

        if (response.data.data.name != null) {
          this.epg.name = response.data.data.name;
        }

        if (response.data.data.source != null) {
          this.source = response.data.data.source;
        }

        if (response.data.data && !response.data.data.source) {
          this.source = "Add an EPG";
        }

        if (response.data.data.mapping != null) {
          this.mapping = response.data.data.mapping;
        }

        if (this.json.original !== null) {
          this.makeRootList();
          this.makeRootJson();
        }

        return response.data.data;
      } catch (error) {
        toastr.info("File sample is not uploaded!");
      }
    },
  },
  components: {
    VueJsonPretty,
  },
  data: () => ({
    epg: {
      uuid: window.epg.uuid,
      name: "Loading...",
      options: {
        timezone: window.epg.options.timezone,
        published: window.epg.options.published,
      },
      liveSource: window.epg.liveSource,
    },
    timezoneSelected: {
      zone: window.epg.options.timezone,
    },
    timezones: window.timezones,
    source: null,
    root: "*",
    rootList: [],
    mappingSuggestions: [],
    showSaveAlert: false,
    mapping: {
      uuid: "",
      name: "",
      description: "",
      image: "",
      broadcast_start: "",
      broadcast_stop: "",
    },
    json: {
      original: null,
      reduced: null,
      preview: null,
      final: null,
    },
  }),
  mounted() {
    this.getEpg();

    const my_dropzone = new window.Dropzone("#my-dropzone", {
      headers: {
        "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]')
          .content,
      },
      url: "/api/v1/epg/items",
      parallelUploads: 1,
      maxFiles: 1,
      params: {
        uuid: window.epg.uuid,
      },
      acceptedFiles: "application/json",
      createImageThumbnails: false,
      success: () => {
        my_dropzone.removeAllFiles();
        this.makeRootList();
        this.root = "*";
        this.json.final = null;
        this.makeRootJson();
        this.getEpg();
      },
      error: () => {
        my_dropzone.removeAllFiles(); // remove all files (even if it is an error!)
      },
    });
    this.initialMapping = this.mapping;
  },
  methods: {
    async getEpg() {
      try {
        const response = await axios.get(`/api/v1/epg/items/${window.epg.uuid}`);
        if (response.data.success) {
          this.source = response.data.data.source;
          this.epg.options.timezone = response.data.data.timezone;
          this.epg.options.published = response.data.data.published;
        }
      } catch (error) {
        toastr.error("Oops! Something went wrong!");
        console.error(error);
      }
    },
    async previewMapping() {
      try {
        this.saveChanges();
        this.epg.options.timezone = this.timezoneSelected.zone;
        const response = await axios.post("/api/v1/epg/previewmapping", {
          mappings: this.mapping,
          json: this.json.preview,
          options: this.epg.options,
        });
        this.json.final = response.data;
        // scroll to bottom
        $("html, body").animate(
          {
            scrollTop: document.body.scrollHeight,
          },
          "slow",
        );
      } catch (error) {
        console.error(error);
      }
    },

    async saveChanges() {
      try {
        const response = await axios.put(
          `/api/v1/epg/json/${window.epg.uuid}`,
          {
            mapping: this.mapping,
            root: this.root,
            options: this.epg.options,
            liveSource: this.epg.liveSource,
          },
        );

        if (response) {
          toastr.success("EPG Saved.");
        }
      } catch (error) {
        console.error(error);
      }
    },

    async makeRootJson() {
      const response = await axios.post("/api/v1/epg/makerootjson", {
        uuid: window.epg.uuid,
        root: this.root,
      });
      // after root element is applied...
      this.json.reduced = response.data;
      // get random sample of 5 from reduced for output rendering
      this.json.preview = _.sampleSize(response.data, 5);
      this.getMappingSuggestions();
    },
    async getMappingSuggestions() {
      const response = await axios.post("/api/v1/epg/mappings/suggestions", {
        json: this.json.reduced,
      });
      this.mappingSuggestions = response.data;
    },
    async makeRootList() {
      const response = await axios.post("/api/v1/epg/rootelems", {
        uuid: window.epg.uuid,
        json: this.json.original,
      });
      this.rootList = response.data;
    },
    exampleJson() {
      this.$modal.show("json-examples");
    },
  },
};
</script>

<style>
.multiselect--active {
  z-index: 9999;
}

.dropzone-file-area {
  border: 2px dashed #028af4;
  background: white;
  padding: 20px;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.filesource {
  width: 100%;
  word-break: break-all;
}
</style>
